import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Checkbox,
  DatePicker,
  DayOfWeek,
  DefaultButton,
  defaultDatePickerStrings,
  Dropdown,
  Modal,
  PrimaryButton,
  TextField,
} from '@fluentui/react';
import * as Api from '../../../api/src';
import ModalHeader from '../../../control/modalHeader';
import Moment from 'moment';
import ErrorMesage from '../../../control/MessageBar/Error';
import { ToastAppMsgContext } from '../../../context/toastApp.Context';
import { ToastAppType } from '../../../common/constant/enum/toastAppType';

export interface TestDataProps {
  VendorId?: number | null;
  ComponentId?: number | null;
  CBrandId?: number | null;
  CModelId?: number | null;
}
export interface ModaTestProps {
  IsOpen: boolean;
  productypeId: number | null;
  onCloseModal: () => void;
  onSaveClick?: () => void;
  Item?: Api.Test | null;
  Data?: TestDataProps | null;
}
const VendorsApi = new Api.VendorsApi();
const ProductTypesApi = new Api.ProductTypesApi();
const ComponentsApi = new Api.ComponentsApi();
const TestsApi = new Api.TestsApi();
const ModaTest = ({ Item, IsOpen, onCloseModal, onSaveClick, productypeId, Data }: ModaTestProps) => {
  const { t } = useTranslation();
  const [modalMessage, SetModalMessage] = React.useState('');
  const [isShow, SetIsShow] = React.useState(false);
  const [detail, SetDetail] = React.useState<Api.AddEditTestCommand>({});
  const [nameErrorMessage, SetNameErrorMessage] = React.useState('');
  const [listProductType, setListProductType] = React.useState<any[]>([]);
  const [listVendor, setListVendor] = React.useState<any[]>([]);
  const [productTypeErrorMessage, SetProductTypeErrorMessage] = React.useState('');
  const [ProductVendorErrorMessage, SetProductVendorErrorMessage] = React.useState('');
  const [ComponentErrorMessage, SetComponentErrorMessage] = React.useState('');
  const [TestDateErrorMessage, SetTestDateErrorMessage] = React.useState('');
  const [ExpireDateErrorMessage, SetExpireDateErrorMessage] = React.useState('');
  const [componentModelErrorMessage, SetComponentModelErrorMessage] = React.useState('');
  const [listComponentModel, setListComponentModel] = React.useState<Api.CModelModel[]>([]);
  const [listComponentModelFilter, setListComponentModelFilter] = React.useState<any[]>([]);
  const [listComponent, setListComponent] = React.useState<any[]>([]);
  const [listComponentBrand, setListComponentBrand] = React.useState<Api.CBrandModel[]>([]);
  const [listComponentBrandFilter, setListComponentBrandFilter] = React.useState<any[]>([]);
  const [cBrandId, setCBrandId] = React.useState<any>(null);
  const { setToastData } = React.useContext(ToastAppMsgContext);
  const getItemData = async () => {
    var data = (await TestsApi.apiTestsIdGet(Item?.Id || 0)).data;
    detail.Model = data.Data;
  };
  const InitData = async () => {
    SetIsShow(IsOpen);
    if (IsOpen) {
      if (Item == null) {
        detail.Model = {
          States: Api.StatesEnum.Active,
          ProductTypeId: (productypeId || 0) > 0 ? productypeId || undefined : undefined,
          ComponentId: Data?.ComponentId || undefined,
          CModelId: Data?.CModelId,
          VendorId: Data?.VendorId || undefined
        };
        setCBrandId(Data?.CBrandId);
      } else {
        await getItemData();
      }
      SetDetail({ ...detail });
    } else {
      SetDetail({ Model: { States: Api.StatesEnum.Active } });
    }
    await getAllProductTypes();
    SetNameErrorMessage('');
    SetProductVendorErrorMessage('');
    SetComponentErrorMessage('');
    SetTestDateErrorMessage('');
    SetExpireDateErrorMessage('');
    SetComponentModelErrorMessage('');
  };
  React.useEffect(() => {
    (async () => {
      await InitData();
    })();
  }, [IsOpen]);
  React.useEffect(() => {
    getAllVendors(detail.Model?.ProductTypeId || 0);
    getAllComponents();
    getAllBrands();
    getAllModels();
  }, [detail.Model?.ProductTypeId]);
  const getTitle = (): string => {
    if (Item) {
      return t('EditTest');
    }
    return t('NewTest');
  };
  const onClose = () => {
    onCloseModal();
    SetIsShow(false);
  };
  const validateFormData = () => {
    let pass = true;
    if (!detail.Model?.Name) {
      SetNameErrorMessage(t('ModuleNameIsRequired'));
      pass = false;
    }
    if (!detail.Model?.VendorId) {
      SetProductVendorErrorMessage(t('IsRequired').replace('{0}', t('ProductVendor')));
      pass = false;
    }
    if (!detail.Model?.ComponentId) {
      SetComponentErrorMessage(t('IsRequired').replace('{0}', t('Component')));
      pass = false;
    }
    if (!detail.Model?.CModelId) {
      SetComponentModelErrorMessage(t('IsRequired').replace('{0}', t('Component')));
      pass = false;
    }
    if (!detail.Model?.TestDate) {
      SetTestDateErrorMessage(t('IsRequired').replace('{0}', t('TestDate')));
      pass = false;
    }
    if (!detail.Model?.ExpiredDate) {
      SetExpireDateErrorMessage(t('IsRequired').replace('{0}', t('ExpiredDate')));
      pass = false;
    }
    if (detail.Model?.TestDate && detail.Model?.ExpiredDate) {
      let TestDate = Moment(detail.Model?.TestDate) as Moment.Moment;
      let ExpiredDate = Moment(detail.Model?.ExpiredDate);
      if (TestDate.unix() > ExpiredDate.unix()) {
        SetModalMessage(t('TestDateHasToBeLessThanExpireDate'));
        pass = false;
      }
    }
    return pass;
  };
  const onSave = async () => {
    if (!validateFormData()) {
      return;
    }
    var data = await TestsApi.apiTestsPost(detail);
    if (!data || data.status !== 200) return;
    setToastData({ Message: t('Successed'), Type: ToastAppType.Success });
    onCloseModal();
    SetIsShow(false);
    if (onSaveClick) {
      onSaveClick();
    }
  };
  const getAllProductTypes = async () => {
    let productTypes: any[] = listProductType || [];
    if (productTypes.length === 0) {
      let data = (
        await ProductTypesApi.apiProductTypesPagedPost({
          PageNumber: 1,
          OrderBy: [{ ColumnName: 'Name' }],
          PageSize: 0,
          SearchString: '',
          GetOnlyActive: true,
        })
      ).data;
      data.Data?.forEach((element) => {
        productTypes.push({ key: element.Id, text: element.Name });
      });
      setListProductType(productTypes);
    }
    if (!productTypes.length) {
      productTypes.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
  };
  const getAllComponents = async () => {
    let components: any[] = [];
    if ((detail.Model?.ProductTypeId || 0) <= 0) {
      return;
    }
    let data = (
      await ComponentsApi.apiComponentsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
        ProductTypeId: productypeId || 0,
      })
    ).data;
    data.Data?.forEach((element) => {
      components.push({ key: element.Id, text: element.Name });
    });
    if (!components.length) {
      components.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListComponent(components);
  };
  const getAllVendors = async (productypeId: number) => {
    if (productypeId === 0) return;
    let data = (
      await VendorsApi.apiVendorsPagedPost({
        PageNumber: 1,
        OrderBy: [{ ColumnName: 'Name' }],
        PageSize: 0,
        SearchString: '',
        GetOnlyActive: true,
        ProductTypeId: productypeId,
      })
    ).data;
    let vendors: any[] = [];
    data.Data?.forEach((element) => {
      vendors.push({ key: element.Id, text: element.Name });
    });
    if (!vendors.length) {
      vendors.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListVendor(vendors);
  };

  const getAllBrands = async () => {
    
    if ((detail.Model?.ProductTypeId || 0) <= 0) {
      return;
    }
    let data = (
      await ComponentsApi.getCBrands({
        Page: 0,
        SortField: 'Name',
        PageSize: 0,
        Search: '',
        GetOnlyActive: true,
        ProductTypeId: productypeId || 0,
      })
    ).data;
    setListComponentBrand(data.Data ?? []);
    if(!Item && !Data) return;
    let result = data.Data?.filter((x) => x.ComponentIds?.includes(Item?.ComponentId ?? detail.Model?.ComponentId ?? 0));
    let brands: any[] = [];
    result?.forEach((element) => {
      brands.push({ key: element.Id, text: element.Name });
    });
    if (!brands.length) {
      brands.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListComponentBrandFilter(brands);
  };

  const getAllModels = async () => {
    if ((detail.Model?.ProductTypeId || 0) <= 0) {
      return;
    }
    let data = (
      await ComponentsApi.getCModels({
        Page: 0,
        SortField: 'Name',
        PageSize: 0,
        Search: '',
        GetOnlyActive: true,
        ProductTypeId: productypeId || 0,
      })
    ).data;
    setListComponentModel(data.Data ?? []);
    if(!Item && !Data) return;
    let model = data.Data?.find((x) => x.Id === (Item?.CModelId ?? detail.Model?.CModelId));
    setCBrandId(model?.CBrandId ?? 0);
    let models: any[] = [];
    data.Data?.filter((x) => (detail.Model?.ComponentId === 0 || x.ComponentId === detail.Model?.ComponentId) && (cBrandId === 0 || x.CBrandId === cBrandId))
    .forEach((element) => {
      models.push({ key: element.Id, text: element.Name });
    });
    if (!models.length) {
      models.push({
        key: null,
        text: t('NoDataFound'),
        disabled: true,
      });
    }
    setListComponentModelFilter(models);
  };

  const filterModels = () => {
    let models = listComponentModel.filter((x) => x.ComponentId === detail.Model?.ComponentId && (cBrandId === 0 || x.CBrandId === cBrandId))
      .map((x) => ({
        key: x.Id || null, text: x.Name, disabled: false
      }));
      if (!models.length) {
        models.push({
          key: null,
          text: t('NoDataFound'),
          disabled: true,
        });
      }
    setListComponentModelFilter(models);
  }
  const filterBrands = () => {
    let brands = listComponentBrand.filter((x) => x.ComponentIds?.includes(detail.Model?.ComponentId ?? 0))
      .map((x) => ({
        key: x.Id || null, text: x.Name, disabled: false
      }));
      if (!brands.length) {
        brands.push({
          key: null,
          text: t('NoDataFound'),
          disabled: true,
        });
      }
    setListComponentBrandFilter(brands);
  }

  React.useEffect(() => {
    filterBrands();
    filterModels();
  }, [detail.Model?.ComponentId]);
  React.useEffect(() => {
    filterModels();
  }, [cBrandId]);

  return (
    <Modal isOpen={isShow} isModeless={true}>
      <ModalHeader
        title={getTitle()}
        onCloseModal={() => {
          onClose();
        }}
      />
      <div className={'modal-content'} style={{ width: 700 }}>
        <div className="ms-Grid" dir="ltr">
          {modalMessage && (
            <div className="ms-Grid-row">
              <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
                <ErrorMesage
                  Message={modalMessage}
                  onClose={() => {
                    SetModalMessage('');
                  }}
                />
              </div>
            </div>
          )}

          <div className="ms-Grid-row">
            <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
              <TextField
                label={t('TestName') + ' (*)'}
                autoFocus={true}
                maxLength={100}
                errorMessage={nameErrorMessage}
                value={detail.Model?.Name || ''}
                onChange={(e, newValue) => {
                  SetDetail({ ...detail, Model: { ...detail.Model, Name: newValue } });
                  SetNameErrorMessage('');
                }}
              ></TextField>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
              <TextField
                label={t('Description')}
                value={detail.Model?.Description || ''}
                onChange={(e, newValue) => {
                  SetDetail({ ...detail, Model: { ...detail.Model, Description: newValue } });
                }}
              ></TextField>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12 padding-right-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={listProductType}
                disabled={true}
                label={t('ProductType') + ' (*)'}
                placeholder={t('SelectAProductType')}
                errorMessage={productTypeErrorMessage}
                selectedKey={detail.Model?.ProductTypeId || ''}
                onChange={(e, opt, index) => {
                  SetDetail({
                    ...detail,
                    Model: {
                      ...detail.Model,
                      ProductTypeId: opt?.key as number,
                      VendorId: undefined,
                      ComponentId: undefined,
                    },
                  });
                  SetProductTypeErrorMessage('');
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12 padding-right-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={listVendor}
                label={t('ProductVendor') + ' (*)'}
                disabled={Item != null}
                placeholder={t('SelectAProductVendor')}
                errorMessage={ProductVendorErrorMessage}
                selectedKey={detail.Model?.VendorId || ''}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetDetail({ ...detail, Model: { ...detail.Model, VendorId: parseInt(opt?.key.toString()) } });
                  }
                  SetProductVendorErrorMessage('');
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12 padding-right-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={listComponent}
                disabled={Item != null}
                label={t('Component') + ' (*)'}
                placeholder={t('SelectAComponent')}
                errorMessage={ComponentErrorMessage}
                selectedKey={detail.Model?.ComponentId || ''}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetDetail({ ...detail, Model: { ...detail.Model, ComponentId: opt?.key as number, CModelId: 0 } });
                    setCBrandId(0);
                  }
                  SetComponentErrorMessage('');
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12 padding-right-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={listComponentBrandFilter}
                label={t('ComponentBrand')}
                disabled={Item != null}
                placeholder={t('SelectAComponentBrand')}
                selectedKey={cBrandId || ''}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetDetail({ ...detail, Model: { ...detail.Model, CModelId: 0 } });
                    setCBrandId(opt?.key as number);
                  }
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md12 padding-right-0 padding-left-0 ms-Grid-col">
              <Dropdown
                options={listComponentModelFilter}
                disabled={Item != null}
                label={t('ComponentModel') + ' (*)'}
                placeholder={t('SelectAComponentModel')}
                errorMessage={componentModelErrorMessage}
                selectedKey={detail.Model?.CModelId || ''}
                onChange={(e, opt, index) => {
                  if (opt?.key) {
                    SetDetail({ ...detail, Model: { ...detail.Model, CModelId: opt?.key as number } });
                  }
                  SetComponentModelErrorMessage('');
                }}
              ></Dropdown>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md6 padding-left-0 ms-Grid-col">
              <DatePicker
                label={t('TestDate') + ' (*)'}
                firstDayOfWeek={DayOfWeek.Sunday}
                showWeekNumbers={true}
                firstWeekOfYear={1}
                showMonthPickerAsOverlay={true}
                isRequired={!!TestDateErrorMessage}
                value={detail.Model?.TestDate ? Moment(detail.Model?.TestDate).toDate() : Item == null ? undefined: new Date()}
                placeholder="dd/mm/yyyy"
                formatDate={(date?: Date): string => {
                  return Moment(date).format('DD/MM/yyyy');
                }}
                onSelectDate={(date: Date | null | undefined) => {
                  SetDetail({ ...detail, Model: { ...detail.Model, TestDate: Moment(date).format('MM/DD/yyyy') } });
                }}
                strings={defaultDatePickerStrings}
              />
            </div>
            <div className="ms-md6 padding-right-0 ms-Grid-col">
              <DatePicker
                label={t('ExpiredDate') + ' (*)'}
                firstDayOfWeek={DayOfWeek.Sunday}
                showWeekNumbers={true}
                firstWeekOfYear={1}
                value={detail.Model?.ExpiredDate ? Moment(detail.Model?.ExpiredDate).toDate() : Item == null ? undefined: new Date()}
                showMonthPickerAsOverlay={true}
                placeholder="dd/mm/yyyy"
                formatDate={(date?: Date): string => {
                  return Moment(date).format('DD/MM/yyyy');
                }}
                isRequired={!!ExpireDateErrorMessage}
                strings={defaultDatePickerStrings}
                onSelectDate={(date: Date | null | undefined) => {
                  SetDetail({ ...detail, Model: { ...detail.Model, ExpiredDate: Moment(date).format('MM/DD/yyyy') } });
                }}
              />
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
              <Checkbox
                label={t('Active')}
                checked={detail.Model?.States === Api.StatesEnum.Active ? true : false}
                onChange={(e, checked) => {
                  SetDetail({
                    ...detail,
                    Model: { ...detail.Model, States: checked ? Api.StatesEnum.Active : Api.StatesEnum.Inactive },
                  });
                }}
              ></Checkbox>
            </div>
          </div>
        </div>
      </div>
      <div className={'modal-footer'}>
        <DefaultButton
          className={'margin-left-10'}
          onClick={() => {
            onClose();
          }}
        >
          {t('Close')}
        </DefaultButton>
        <PrimaryButton
          className={'margin-left-10'}
          onClick={() => {
            onSave();
          }}
        >
          {t('Save')}
        </PrimaryButton>
      </div>
    </Modal>
  );
};
export default ModaTest;
